<template>
  <div class="description">
      <section>
      <div class="header">什么是放心转</div>
      <div class="content">
        【放心转】是转转为保障平台交易用户安全，推出的欺诈赔付产品。如果您在购物过程中遇到交易欺诈并造成资产损失，平台将全力协助您追款，符合条件的可向平台申请赔付。
      </div>
    </section>

    <section>
      <div class="header">
        赔付规则
        <div class="moreinfo" @click="toMore()">
          查看全部规则<z-icon name="arrow" size="12px" />
        </div>
      </div>
      <div class="article">
        <div class="title" v-for="(item, idx) in KnowledgeList" :key="idx">
          <div class="title-idx">{{ idx + 1 }}、</div>
          <div class="title-content">{{ item }}；</div>
        </div>
      </div>
    </section>

    <section>
      <div class="header">赔付流程</div>
      <div>
        <z-image
          class="cover-img"
          px2rem
          src="https://pic2.zhuanstatic.com/zhuanzh/n_v2cfca5f925c88462b98d3263c0bac4c4e.png?w=1800&qa=100"
        />
      </div>
    </section>

    <section>
      <div class="header">常见问题</div>
      <question-list />
    </section>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Icon, Image } from '@zz-common/zz-ui'
import QuestionList from '../Components/QuestionList'

const KnowledgeList = [
  '须为实物商品交易',
  '交易全程在转转平台（包括但不限于：下单、支付、沟通等）',
  '订单状态为交易完成，且造成货物&钱款均在一方手中',
  '由平台判定欺诈事实成立',
  '须上传收货开箱/打包发货视频',
  '买卖双方的交易行为未违反《商品发布条例》《平台商品治理》等平台规则',
  '单个用户赔付上限2000元，一个用户一年内只能申请一笔订单赔付'
]

export default {
  name: 'DescripTion',
  data() {
    return {
      expend: false,
      KnowledgeList
    }
  },
  components: {
    zIcon: Icon,
    zImage: Image,
    QuestionList
  },
  methods: {
    expendHistory() {
      this.expend = !this.expend
    },
    toMore() {
      setTimeout(() => {
        native.skipToUrl({
          targetUrl: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescriptionLaw'
        })
      }, 50)
    }
  },
  mounted() {
    native.setTitle({
      title: '放心转'
    })
  },
  destroyed() {},
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
